/**
 * Media reference types
 * @module services/media-assets/reference-types
 */
import { Map } from 'immutable'

/**
 * The asset represents a closed caption
 */
export const MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_CLOSED_CAPTION = 'cc'

/**
 * The asset represents a subtitle
 */
export const MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_SUBTITLE = 'st'

/**
 * The asset represents a chapter
 */
export const MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_CHAPTER = 'ch'

/**
 * The asset represents a playable media stream i.e. hls
 */
export const MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_MEDIA_STREAM = 'ms'

/**
 * A list of media asset reference type labels
 */
export const MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_LABELS = Map({
  [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_CLOSED_CAPTION]: 'Closed Caption',
  [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_SUBTITLE]: 'Subtitle',
  [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_CHAPTER]: 'Chapter',
  [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_MEDIA_STREAM]: 'Media Stream',
})

/**
 * Get a label give a media asset reference type
 * @param {String} mediaReferenceType The media asset reference type
 * @returns {String} The label if found or an empty string
 */
export function getMediaAssetMediaReferenceTypeLabel (mediaReferenceType) {
  return MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_LABELS.get(mediaReferenceType) || ''
}

/**
 * Gets the CSS class name for a media reference type chip
 * @param {string} mediaReferenceType - The media reference type (e.g., 'cc', 'st', 'ms')
 * @returns {string} The CSS class name for the media reference type
 */
export function getMediaReferenceTypeChipClass (mediaReferenceType) {
  const mediaReferenceTypeClassMap = {
    [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_CLOSED_CAPTION]: 'media-reference-type-chip--closed-caption',
    [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_SUBTITLE]: 'media-reference-type-chip--subtitle',
    [MEDIA_ASSETS_MEDIA_REFERENCE_TYPE_MEDIA_STREAM]: 'media-reference-type-chip--media-stream',
  }
  return mediaReferenceTypeClassMap[mediaReferenceType] || 'media-reference-type-chip--default'
}
